import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  downloadReportPdf: 'idle',
  strippingResults: {
    data: [],
    units: {},
    paginatedElements: 0
  },
};
const strippingReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.STRIPPING_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.STRIPPING_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        units: { ...action.payload.units },
        paginatedElements: action.payload.paginatedElements,
        permissionId: action?.payload?.permissionId ?? null,
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        createdDetails: action?.payload?.lastUpdate
          ? {
              createdBy: action?.payload?.createdBy,
              lastUpdate: action?.payload?.lastUpdate,
              lastUpdatedBy: action?.payload?.lastUpdatedBy
            }
          : state?.createdDetails,
        errorMessage: ''
      };
    case REDUX_ACTIONS.STRIPPING_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.STRIPPING_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.STRIPPING_SET_FALSE:
      return {
        ...state,
        loading: false,
        errorMessage: ''
      };
    case REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_LOADING:
      return {
        ...state,
        downloadReportPdf: 'loading'
      };
    case REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_IDLE:
      return {
        ...state,
        downloadReportPdf: 'idle'
      };
    case REDUX_ACTIONS.DOWNLOAD_STRIPPING_PDF_ERROR:
      return {
        ...state,
        downloadReportPdf: 'error'
      };
    case REDUX_ACTIONS.HYDRAULICS_STRIPPING_RESULT_LIST_LOADING:
      return {
        ...state,
        strippingResults: {
          ...state.strippingResults,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_STRIPPING_RESULT_LIST_SUCCESS:
      return {
        ...state,
        strippingResults: {
          ...state.strippingResults,
          loading: false,
          data: [...action.payload.data],
          units: { ...action.payload.units },
          paginatedElements: action.payload.paginatedElements,
          errorMessage: '',
          ph_version: action.payload?.ph_version
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_STRIPPING_RESULT_LIST_ERROR:
      return {
        ...state,
        strippingResults: {
          ...state.strippingResults,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.STRIPPING_RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
export default strippingReducer;
